import { Component, OnInit, OnDestroy } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { Subscription } from 'rxjs';
import { InvoicepageService } from './invoicepage.service';
import { OrderResult } from '../../../../core/services/orders/order.models';
import { FuseConfigService } from '../../../../core/services/config.service';
import { Transaction } from '../../../../core/services/transactions/transactions.model';

@Component({
  selector: 'fuse-invoicepage',
  templateUrl: './invoicepage.component.html',
  styleUrls: ['./invoicepage.component.scss']
})
export class InvoicepageComponent implements OnInit, OnDestroy {
    order: OrderResult;
    transactions: Transaction[];
    dueAmount: number;

    onOrderChanged: Subscription;

    constructor(
        private fuseConfig: FuseConfigService,
        private orderService: InvoicepageService,
    ) { }

    ngOnInit() {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar   : 'none',
                footer    : 'none'
            }
        });

        this.onOrderChanged =
            this.orderService.onOrderChanged
                .subscribe((pair: any[]) => {
                    this.order = pair[0];
                    this.transactions = pair[1];
                    this.dueAmount = pair[2];
                    setTimeout(() => window.print(), 2500);
                });
    }

    ngOnDestroy()
    {
        this.onOrderChanged.unsubscribe();
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/invoicepage/invoicepage.component.ts